import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const ITEMS_PER_PAGE = 20;

const TestCategories_List = () => {
    const [catList, setCategoryList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        const token = localStorage.getItem("jwt_token");
        const fetchCategoriesList = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}api/getCategoriesList`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                if (Array.isArray(data.data)) {
                    setCategoryList(data.data);
                    console.log('Categories:', data);
                } else {
                    console.error('Data is not an array:', data);
                    setCategoryList([]);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        };

        fetchCategoriesList();
    }, []);

    // Pagination calculations
    const totalPages = Math.ceil(catList.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const currentItems = catList.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    return (
        <div className="wrapper">
            <Sidebar />
            <main className="main-content content-page">
                <div className="position-relative">
                    <Navbar />
                </div>
                <div className="content-inner container-fluid pb-0" id="page_layout">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header-custom d-flex justify-content-between p-4 mb-0 row">
                                    <div className="header-title col-4">
                                        <h4 className="card-title">Test Categories List</h4>
                                    </div>
                                    <div className="header-action col-8">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group mb-0">
                                                    <input type="text" className="form-control form-control-sm" placeholder="Search" />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="d-flex justify-content-end">
                                                    <Link to="/add_testcategory" className="btn btn-sm btn-primary">Add Test Category</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>tc id</th>
                                        <th>Test Category</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.map((cat, index) => (
                                        <tr key={cat.id}>
                                            <th scope="row">{startIndex + index + 1}</th>
                                            <td>{cat.id}</td>
                                            <td>{cat.test_category}</td>
                                            <td>
                                                <Link to={`/edit_tc/${cat.id}`} className="btn btn-sm btn-primary">Edit</Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination Controls */}
                        <div className="col-12">
                            <nav className="d-flex justify-content-center">
                                <ul className="pagination">
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                                    </li>
                                    {[...Array(totalPages)].map((_, index) => (
                                        <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                            <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                                                {index + 1}
                                            </button>
                                        </li>
                                    ))}
                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                    </div>
                </div>
            </main>
        </div>
    );
};

export default TestCategories_List;
